var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBanWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBanWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.38331451,0 0,5.3829482 0,12 C0,18.6170518 5.3829482,24 12,24 C18.6170518,24 24,18.6170518 24,12 C24,5.3829482 18.6166855,0 12,0 Z M2.19786929,12 C2.19786929,6.59507311 6.59507311,2.19786929 12,2.19786929 C14.4352392,2.19786929 16.6646113,3.0927684 18.3807809,4.56863763 L4.56863763,18.3807809 C3.0927684,16.6646113 2.19786929,14.4352392 2.19786929,12 Z M12,21.8021307 C9.82117891,21.8021307 7.80683171,21.0867243 6.17747794,19.8797277 L19.8793614,6.17784426 C21.0863579,7.80719802 21.8017644,9.82154522 21.8017644,12.0003663 C21.8021307,17.4049269 17.4049269,21.8021307 12,21.8021307 Z",
    id: "icBanWhite",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBanWhite);
export default __webpack_public_path__ + "static/media/icBanWhite.c7955b3eb2f6c140a203dbfd8d70b88f.svg";
export { ForwardRef as ReactComponent };